import React, { useEffect, useState } from "react";
import { CalendarOutlined, CheckCircleOutlined, DownOutlined, EnvironmentOutlined, EyeInvisibleOutlined, EyeTwoTone, FieldTimeOutlined, QuestionCircleOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, Alert, Tag, Space, Select, Modal, Table, Card, DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { useParams } from 'react-router-dom';

import IntlMessages from "util/IntlMessages";
import InfoView from "components/InfoView";
import { daftarAffiliateChecker, daftarDiscountChecker, getUser, setErrorMessage, userSignIn } from "../../appRedux/actions";
import { baseRequest, client } from "../../util/Api";
import { FAILED_LOGIN, FETCH_ERROR, FETCH_SUCCESS, TWOFA_REQUIRED, UPDATE_USER, USER_TOKEN_SET } from "../../constants/ActionTypes";
import CircularProgress from "../../components/CircularProgress";
import PhoneInput from "react-phone-number-input";
import { toRupiah } from "../../libs";
import { getTrainingBundleParticipant } from "../../appRedux/actions/TrainingBundles";

export default function CheckoutPage() {
  const dispatch = useDispatch();
  const authUser = useSelector(({ auth }) => auth.authUser);
  const twofaRequired = useSelector(({ auth }) => auth.twofaRequired);
  const numOfFailedLogin = useSelector(({ auth }) => auth.failed);
  const recaptchaRef = React.createRef();

  const [training, setTraining] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [emailVerified, setEmailVerified] = useState(null);
  const [rules, setRules] = useState("")
  const [showAlert, setShowAlert] = useState(false)
  const [selectedBundling, setSelectedBundling] = useState(null);
  const [bundlingWarning, setBundlingWarning] = useState(false);
  const [showAdvancedFields, setShowAdvancedFields] = useState(false);
  const [inputDiscountCode, setInputDiscountCode] = useState("");
  const [discountPercent, setDiscountPercent] = useState(null);
  const [discountPrice, setDiscountPrice] = useState(null);
  const [discountId, setDiscountId] = useState(null);
  const [inputAffiliateCode, setInputAffiliateCode] = useState("");
  const [affiliatePercent, setAffiliatePercent] = useState(0);
  const [affiliateCode, setAffiliateCode] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const { trainingId } = useParams();
  const [form] = Form.useForm()

  const onFinishFailed = (errorInfo) => { };

  const onFinish = async (values) => {
    if (captchaRequired()) {
      values.recaptcha = recaptchaRef.current.getValue();
      if (!values.recaptcha) {
        dispatch({ type: FETCH_ERROR, payload: "Harap masukkan Captcha!" })
        return false;
      }
    }
    Modal.confirm({
      title: "Konfirmasi",
      content: "Apakah sudah yakin dengan data yang dimasukkan?",
      onOk: () => {
        setIsProcessing(true);
        if (recaptchaRef.current)
          recaptchaRef.current.reset();

        values = {
          ...values,
          discount_id: !selectedBundling ? discountId : null,
          affiliate_code: affiliateCode,
          training_bundle_id: selectedBundling ? selectedBundling.training_bundle_id : null,
          training_bundle_training_id: selectedBundling ? selectedBundling.id : null,
          utm_params: localStorage.getItem("utm_params"),
        }
        let url = "/checkout/register";
        if (emailVerified === true)
          url = "/checkout/login";
        if (authUser)
          url = "/checkout/authenticated";
        baseRequest("post", url, null, values).then(data => {
          if (!data)
            return
          setShowAlert(true)
          const elmnt = document.getElementById("alert-message")
          if (elmnt) {
            elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          if (emailVerified === true) {
            localStorage.setItem("token", data.token);
            dispatch({ type: USER_TOKEN_SET, payload: data.token });
            dispatch({ type: TWOFA_REQUIRED, payload: data.twofa_required });
            client.defaults.headers.common["Authorization"] = "Bearer " + data.token;
            if (!data.twofa_required) {
              baseRequest("get", "auth/me").then(data => {
                dispatch({
                  type: UPDATE_USER,
                  payload: data,
                });
              });
            }
          }
        }).catch(e => {
          dispatch({ type: FETCH_ERROR, payload: e });
        }).finally(() => {
          setIsProcessing(false);
        })
      }
    })
  };

  const captchaRequired = () => {
    return numOfFailedLogin > 2 || emailVerified === false;
  }

  const captchaRequiredByEmail = async (email) => {
    const data = await baseRequest("get", `/auth/captcha/${email.trim()}`);
    if (data.required) {
      dispatch({ type: FAILED_LOGIN });
      dispatch({ type: FAILED_LOGIN });
      dispatch({ type: FAILED_LOGIN });
    }
  }

  const verify = async () => {
    const email = form.getFieldValue('email');
    const data = await baseRequest("post", `/auth/verify`, null, { email: email });
    try {
      if (data.user !== null) {
        setEmailVerified(true);
        return;
      }
    } catch (e) { }
    setEmailVerified(false);
  }

  async function showBundlingOptions(bundle_ids) {
    const data = await getTrainingBundleParticipant(training.training_option.id, bundle_ids);
    const dataSource = [];
    data.map(d => {
      d.trainings.map(t => {
        dataSource.push({
          key: t.id,
          id: t.id,
          name: t.name,
          dates_summary: t.dates_summary,
          time_start: t.time_start,
          time_end: t.time_end,
          is_online: t.is_online,
          location: t.location,
          price: d.price,
          training_bundle_id: d.id,
        })
      })
    })
    const modal = Modal.confirm({
      title: "Pilih Bundling",
      centered: true,
      width: 900,
      closable: true,
      icon: <QuestionCircleOutlined />,
      content: <div>
        <Table
          dataSource={dataSource}
          columns={[
            {
              title: 'Name',
              dataIndex: 'name',
              key: 'name',
            },
            {
              title: 'Lokasi',
              dataIndex: 'location',
              key: 'location',
              render: (location, field) => (<>
                {location ? location : <>
                  {field.is_online ?
                    <span style={{ color: "green" }}>ONLINE</span>
                    :
                    <span style={{ color: "blue" }}>OFFLINE</span>}
                </>
                }
              </>),
            },
            {
              title: 'Tanggal',
              dataIndex: 'dates_summary',
              key: 'dates_summary',
            },
            {
              title: 'Waktu',
              dataIndex: 'time_start',
              key: 'time_start',
              render: (time_start, field) => <>{time_start} - {field.time_end}</>,
            },
            {
              title: 'Total Harga Paket',
              dataIndex: 'price',
              key: 'price',
              render: (price, field) => <>{toRupiah(price)}</>,
            },
            {
              title: '',
              render: (field) => <>
                <Button type="primary" onClick={() => {
                  setSelectedBundling(dataSource.find(t => t.id == field.id));
                  modal.destroy();
                }}>Pilih</Button>
              </>,
            },
          ]}
        />
      </div>,
      okButtonProps: {
        style: { display: 'none' }
      },
    })
  }

  useEffect(() => {
    async function getTraining() {
      try {
        const training = await baseRequest("get", "/public/trainings/" + trainingId)
        setTraining(training)
        const data = await baseRequest("get", "/public/daftar", null);
        setRules(data["training_rules"])
        let options = [];
        data["locations"].map((value) => {
          options.push({
            value: value,
            label: value,
          });
        });
      } catch (e) {
        setErrorMessage(e);
      }
      setIsLoading(false)
    }
    getTraining();

  }, []);

  useEffect(() => {
    if (training === null || selectedBundling === null)
      return
    const parsedSelected = parseIndoMultiMonth(training.dates_summary);
    const parsedBundling = parseIndoMultiMonth(selectedBundling.dates_summary);
    const set2 = new Set(parsedBundling);
    const hasOverlap = parsedSelected.some(d => set2.has(d));
    setBundlingWarning(hasOverlap);
  }, [selectedBundling]);

  function parseIndoMultiMonth(str) {
    const months = {
      Januari: 0,
      Februari: 1,
      Maret: 2,
      April: 3,
      Mei: 4,
      Juni: 5,
      Juli: 6,
      Agustus: 7,
      September: 8,
      Oktober: 9,
      November: 10,
      Desember: 11,
    };

    const yearMatch = str.match(/\d{4}/);
    if (!yearMatch) return [];

    const year = parseInt(yearMatch[0]);

    // Hilangkan tahun
    const cleanStr = str.replace(yearMatch[0], "").trim();

    // Split berdasarkan koma
    const segments = cleanStr.split(",");

    const results = [];

    let month = null;
    for (let i = segments.length - 1; i >= 0; i--) {
      const segment = segments[i];
      const words = segment.trim().split(" ");

      if (words.length === 2) {
        // contoh: "28 Februari"
        month = months[words[1]];
      }
      const day = parseInt(words[0]);
      if (month)
        results.push(new Date(year, month, day));

      if (words.length === 3) {
        // contoh: "6 7 8 Maret" (jika tanpa koma)
        month = months[words[words.length - 1]];
        words.slice(0, -1).forEach(d => {
          results.push(new Date(year, month, parseInt(d)));
        });
      }
    }

    return results.map(d => d.toISOString().split("T")[0]);
  }

  const discountAffiliateComponent = () => {
    return <Form.Item shouldUpdate noStyle>
      {() => (selectedBundling == null) && (<>
        <Form.Item>
          <a
            href={() => false}
            onClick={() => setShowAdvancedFields(!showAdvancedFields)}
          >
            {showAdvancedFields ? <UpOutlined /> : <DownOutlined />} Tampilkan
            lebih {showAdvancedFields ? "sedikit" : "banyak"}
          </a>
        </Form.Item>
        <div style={{ display: showAdvancedFields ? "block" : "none" }}>
          <Form.Item noStyle shouldUpdate>
            {() =>
              <>
                {!selectedBundling && (
                  <Form.Item
                    label="Kode Diskon (Pastikan klik tombol “Terapkan Kode”)"
                    name="discount_id"
                  >
                    <Space wrap>
                      <Input.Search
                        placeholder="MASUKKAN KODE"
                        enterButton={"Terapkan Kode"} // <SendOutlined />
                        style={{ width: "300px" }}
                        value={inputDiscountCode}
                        onChange={(e) => setInputDiscountCode(e.target.value)}
                        onSearch={
                          inputDiscountCode !== ""
                            ? async () => {
                              const result = await dispatch(
                                daftarDiscountChecker({
                                  code: inputDiscountCode,
                                  training_id: training.id,
                                })
                              );
                              setDiscountPercent(result.percent);
                              setDiscountPrice(result.price);
                              setDiscountId(result.id);
                            }
                            : null
                        }
                      />
                      {discountPercent !== null && (
                        <Tag color="blue" style={{ margin: 0 }}>
                          Diskon {discountPercent}%
                        </Tag>
                      )}
                      {discountPrice !== null && (
                        <Tag color="blue" style={{ margin: 0 }}>
                          Diskon {toRupiah(discountPrice)}
                        </Tag>
                      )}
                    </Space>
                  </Form.Item>
                )}
                <Form.Item
                  label="Kode Affiliasi (Pastikan klik tombol “Terapkan Kode”)"
                  name="affiliate_code"
                >
                  <Space wrap>
                    <Input.Search
                      placeholder="MASUKKAN KODE"
                      enterButton={"Terapkan Kode"} // <SendOutlined />
                      style={{ width: "300px" }}
                      value={inputAffiliateCode}
                      onChange={(e) => setInputAffiliateCode(e.target.value)}
                      disabled={
                        discountPercent === 100
                      }
                      onSearch={
                        inputAffiliateCode !== ""
                          ? async () => {
                            const result = await daftarAffiliateChecker({
                              code: inputAffiliateCode,
                              training_id: training.id,
                            });
                            setAffiliatePercent(0);
                            setAffiliateCode('');
                            if (result) {
                              setAffiliatePercent(5);
                              setAffiliateCode(result.affiliate_code);
                            }
                          }
                          : null
                      }
                    />
                    {affiliatePercent !== 0 && discountPercent !== 100 && (
                      <Tag color="blue" style={{ margin: 0 }}>
                        Diskon {affiliatePercent}%
                      </Tag>
                    )}
                  </Space>
                </Form.Item>
                <Form.Item shouldUpdate noStyle hidden>
                  {() =>
                    form.getFieldValue("already_paid") < 500000 && (
                      <Form.Item
                        label="Batas waktu pelunasan uang muka (Rp 500.000)"
                        name="dp_deadline"
                        rules={[{ required: true, message: "Mohon diisi" }]}
                      >
                        <DatePicker
                          showTime
                          format="dddd, DD MMMM YYYY [pukul] HH:mm"
                          allowClear={false}
                        />
                      </Form.Item>
                    )
                  }
                </Form.Item>
              </>
            }
          </Form.Item>
        </div>
      </>)}
    </Form.Item>
  }

  const checkAndCaptchaComponent = () => {
    return <>
      <Form.Item
        rules={[{ required: true, message: "Mohon untuk menyetujui peraturan training" }]}
        name="rules_checked" valuePropName="checked" label={null}
        onChange={(e) => {
          if (e.target.checked)
            form.setFieldsValue({ rules_checked: "checked" })
          else
            form.setFieldsValue({ rules_checked: null })
        }}
      >
        <Checkbox>Saya telah menyetujui peraturan training <a href="#" onClick={() => {
          Modal.info({
            title: "Peraturan Training",
            centered: true,
            width: 600,
            closable: true,
            icon: <CheckCircleOutlined />,
            content: <div dangerouslySetInnerHTML={{ __html: rules }}></div>,
            onOk: () => { },
          })
        }}>berikut ini</a></Checkbox>
      </Form.Item>
      {captchaRequired() &&
        <Form.Item>
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={() => { }}
          />
        </Form.Item>
      }
    </>
  }

  return (
    <section className="ant-layout ant-layout-has-sider gx-app-layout">
      <main className="ant-layout-content gx-layout-content">
        <div className='gx-main-content-wrapper' style={{ "padding": "1em" }} id="alert-message">
          <div className="gx-app-login-wrap">
            <div className="gx-app-login-container">
              <div className="gx-app-login-main-content">
                <div className="gx-app-logo-content" style={{ "backgroundColor": "#E13849" }}>
                  <div className="gx-app-logo-content-bg">
                    <img src="/bg-rg.jpg" style={{
                      "height": "auto",
                      "position": "absolute",
                      "left": 0,
                      "bottom": 0,
                    }} />
                  </div>
                  <div className="gx-app-logo-wid">
                    <h1>
                      Checkout
                    </h1>
                    <p>
                      Daftarkan diri kamu pada training terbaik dari kami
                    </p>
                  </div>
                  <div className="gx-app-logo">
                    <img
                      alt="example"
                      src="/assets/images/logo-idn.png"
                      width="150"
                    />
                  </div>
                </div>

                <div className="gx-app-login-content">
                  {isLoading ? <CircularProgress /> : <>
                    {(training && !showAlert) &&
                      <Form
                        initialValues={{ training_id: trainingId }}
                        name="basic"
                        layout="vertical"
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        className="gx-signin-form gx-form-row0"
                        form={form}
                        disabled={showAlert}
                      >
                        <Form.Item name="training_id" hidden></Form.Item>
                        <Form.Item label="Pelatihan yang Akan Diikuti:">
                          <Space direction="vertical">
                            <h2 style={{ margin: 0, lineHeight: 1.2, fontWeight: 800, color: "#1d1d1d" }}>
                              {training.training_option.name} {(!selectedBundling) && <div>[{toRupiah(training.price)}]</div>}
                            </h2>
                            <Space>
                              {training.is_online ?
                                <Tag color="green">ONLINE</Tag> :
                                <Tag color="magenta">OFFLINE</Tag>}
                              <Tag color="geekblue">{training.training_category.name}</Tag>
                            </Space>
                            <div style={{ fontWeight: 800, color: "#1d1d1d", textTransform: "uppercase" }}>
                              Jadwal Sesi Pembelajaran
                            </div>
                            <Space>
                              <CalendarOutlined />
                              <div>{training.dates_summary}</div>
                            </Space>
                            <Space>
                              <FieldTimeOutlined />
                              {training.time_start} - {training.time_end}
                            </Space>
                            <div style={{ fontWeight: 800, color: "#1d1d1d", textTransform: "uppercase" }}>
                              Lokasi / Platform
                            </div>
                            <Space>
                              <EnvironmentOutlined />
                              {training.is_online ? <>Online via Zoom Meetings (link dikirim ke email)</> : <>{training.location}</>}
                            </Space>
                          </Space>
                        </Form.Item>
                        {training.available_to_register ? <>
                          {(training.bundles.length > 0) && (
                            <Card
                              size="small"
                              hoverable
                            >
                              <Card.Meta
                                title="Training Bundling"
                                description="Bundle hemat: bayar lebih sedikit, belajar lebih banyak." />
                              <div style={{ marginTop: "1rem" }}>
                                {selectedBundling ? <>
                                  <Space direction="vertical">
                                    <Space size="middle" wrap>
                                      <span>{selectedBundling.name}</span>
                                      {selectedBundling.is_online ?
                                        <span style={{ color: "green" }}>ONLINE</span>
                                        :
                                        <span style={{ color: "blue" }}>OFFLINE</span>
                                      }
                                      <span>{selectedBundling.location && selectedBundling.location}</span>
                                      <span>{selectedBundling.dates_summary}</span>
                                      <span>{selectedBundling.time_start} - {selectedBundling.time_end}</span>
                                      <span><b>{toRupiah(selectedBundling.price)}</b></span>
                                      <Button
                                        type="primary"
                                        size="small"
                                        style={{ margin: 0 }}
                                        onClick={() => setSelectedBundling(null)}
                                      >Batalkan</Button>
                                    </Space>
                                    {bundlingWarning &&
                                      <Alert
                                        message="Tanggal training bundling ada yang sama dengan jadwal training yang dipilih. Apakah anda yakin?"
                                        type="warning"
                                        showIcon
                                        closable={false} />
                                    }
                                  </Space>
                                </> : <>
                                  <Button type="primary" onClick={() => showBundlingOptions(training.bundles)}>Pilih Bundling</Button>
                                </>}
                              </div>
                            </Card>
                          )}
                          {authUser ? <>
                            <Form.Item label="Email Anda">
                              <Input value={authUser.email} readOnly={true} />
                            </Form.Item>
                            <Form.Item label="Nama Lengkap Anda">
                              <Input value={authUser.name} readOnly={true} />
                            </Form.Item>
                            {discountAffiliateComponent()}
                            {checkAndCaptchaComponent()}
                            <Form.Item>
                              <Button type="primary" className="gx-mb-0" htmlType="submit" disabled={isProcessing}>
                                Daftar Training
                              </Button>
                            </Form.Item>
                          </> : <>
                            {(emailVerified === null) && <>
                              <Form.Item
                                label="Email"
                                rules={[{ required: true, message: "Harap masukkan email!" }]}
                                name="email"
                              >
                                <Input placeholder="Masukkan Email"
                                  onBlur={evt => captchaRequiredByEmail(evt.target.value)} />
                              </Form.Item>
                              <Form.Item>
                                <Button type="primary" onClick={verify}>
                                  Lanjutkan Verifikasi
                                </Button>
                              </Form.Item>
                            </>}
                            {(emailVerified === false) && <>
                              <Form.Item
                                label="Email"
                                rules={[{ required: true, message: "Harap masukkan email!" }]}
                                name="email"
                              >
                                <Input readOnly={true} />
                              </Form.Item>
                              <Form.Item
                                label="Nama Lengkap"
                                rules={[{ required: true, message: "Harap masukan nama lengkap!" }]}
                                name="name"
                              >
                                <Input placeholder="Masukkan Nama Lengkap" />
                              </Form.Item>
                              <Form.Item
                                rules={[{ required: true, message: "Harap pilih jenis kelamin!" }]}
                                name="gender"
                                label="Jenis Kelamin"
                              >
                                <Select >
                                  <Select.Option value={"male"}>Laki-laki</Select.Option>
                                  <Select.Option value={"female"}>Perempuan</Select.Option>
                                </Select>
                              </Form.Item>
                              <Form.Item
                                name="whatsapp_number"
                                label="Nomor whatsapp"
                                rules={[
                                  {
                                    required: true,
                                    message: "Mohon masukkan nomor whatsapp!",
                                  },
                                ]}
                              >
                                <PhoneInput
                                  defaultCountry="ID"
                                  style={{ width: "100%" }}
                                  placeholder="081362778829"
                                />
                              </Form.Item>
                              {discountAffiliateComponent()}
                              {checkAndCaptchaComponent()}
                              <Form.Item>
                                <Space>
                                  <Button type='primary' onClick={() => window.location.reload()} disabled={isProcessing}>Kembali</Button>
                                  <Button type="primary" htmlType="submit" disabled={isProcessing}>
                                    Register & Daftar Training
                                  </Button>
                                </Space>
                              </Form.Item>
                            </>}
                            {(emailVerified === true) && <>
                              <Form.Item
                                label="Email"
                                rules={[{ required: true, message: "Harap masukkan email!" }]}
                                name="email"
                              >
                                <Input readOnly={true} />
                              </Form.Item>
                              <Form.Item
                                label="Password"
                                rules={[
                                  { required: true, message: "Harap masukkan password!" },
                                ]}
                                name="password"
                              >
                                <Input
                                  type="password"
                                  placeholder="Masukkan Password"
                                // iconRender={(visible) => (visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>)}
                                />
                              </Form.Item>
                              {discountAffiliateComponent()}
                              {checkAndCaptchaComponent()}
                              <Form.Item>
                                <Space>
                                  <Button type='primary' onClick={() => window.location.reload()} disabled={isProcessing}>
                                    Kembali
                                  </Button>
                                  <Button type="primary" htmlType="submit" disabled={isProcessing}>
                                    Login & Daftar Training
                                  </Button>
                                </Space>
                              </Form.Item>
                            </>}
                          </>}
                        </> : <>
                          <Alert
                            message="Pendaftaran Ditutup"
                            description="Training yang anda pilih sudah tidak menerima pendaftaran peserta"
                            type="error"
                          />
                        </>}
                      </Form>
                    }
                    {(!training && !showAlert) && <>
                      <Alert
                        message="Training Tidak Ditemukan"
                        description="Mohon cek kembali link yang anda pilih"
                        type="error"
                      />
                    </>}
                    {showAlert && (<>
                      <Alert
                        message={"Checkout Berhasil"}
                        description={"Anda berhasil terdaftar dalam training, silahkan check email/whatsapp untuk melihat data akun, jadwal training, dan petunjuk pembayaran (check folder spam, promotions, dll)"}
                        closable={false}
                      />
                      <Link to="/dashboard">
                        <Button type='primary'>
                          {!authUser ? "Login" : "Dashboard"}
                        </Button>
                      </Link>
                    </>)}
                  </>}
                </div>
                <InfoView />
              </div>
            </div>
          </div>
        </div>
      </main>
    </section>
  );
}